import rates from '../consts/rates.json'
import _ from 'lodash';

export default function getCurrencyVolatility(ccy1,ccy2,days) {
  if (!ccy1 || !ccy2) {
    return { averageVol: null, maxVol: null };
  }

  const indexAdjustment = days - Math.floor(days/7)*2;

  const diffArray = [];

  _.forEach(rates, (item, index) => {
    if ( (index + indexAdjustment) >= rates.length) {
      return;
    }
    const farRate = (rates[index + indexAdjustment][ccy1])/rates[index + indexAdjustment][ccy2];
    const currentRate = (item[ccy1])/item[ccy2];

    diffArray.push(Math.abs((farRate/currentRate) -1)*100)

  });

  const averageVol = (_.sum(diffArray)/diffArray.length).toFixed(1);
  const maxVol = (_.max(diffArray)).toFixed(1);
  const medianVol = (diffArray.sort())[Math.floor(diffArray.length/4*3)].toFixed(1);

  return { averageVol, maxVol, medianVol };
}



// WEBPACK FOOTER //
// ./src/services/ratesService.js